import {
  Action,
  AnyAction,
  combineReducers,
  configureStore,
  Reducer,
  ThunkAction,
} from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import adminReducer from 'features/admin/adminSlice';
import appSettingsReducer from 'features/admin/appSettingsSlice';
import authReducer from 'features/auth/authSlice';
import { persistedIntlReducer } from 'features/intl/persistedIntlReducer';
import siteReducer from 'features/site/siteSlice';
import userReducer from 'features/user/userSlice';

const combinedReducer = combineReducers({
  // Authentication & user state (most frequently inspected)
  auth: authReducer,
  user: userReducer,
  // Application state
  appSettings: appSettingsReducer,
  // Domain state
  intl: persistedIntlReducer,
  admin: adminReducer,
  site: siteReducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  return combinedReducer(state, action);
};
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const persistor = persistStore(store);
